
import Vuex from 'vuex'
import Attributions from '@/components/my-home/modals/attributions'

export default {
    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @return {?PsmaAttributionInfo}
             */
            attributions: stateStore => stateStore.myHome.psmaAttributionInfo,
        }),
    },

    methods: {
        /**
         * Event.
         */
        onAttributionsClick() {
            this.$eventbus.$off(this.$appevents.afterModalClose)
            this.$eventbus.$on(this.$appevents.afterModalClose, () => {
                this.$nextTick(() => {
                    this.$logger.logObject({ ref: this.$refs.attributionsLink }, 'Post close action', 'Modal')
                    this.$refs.attributionsLink.focus()
                })
            })
            this.$eventbus.$emit(this.$appevents.showModal, Attributions, {
                data: this.attributions,
                cssModifier: 'attributions',
            })
        },
    },
}
